import PropTypes from 'prop-types';
import React from 'react';
import DropDown from './dropdown/';

class PriceDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prices: [
        { label: 'No Minimum', value: 0 },
        { label: 'No Maximum', value: 1000000000 },
      ],
      minValue: props.min,
      maxValue: props.max
    };
  }

  componentDidMount = () => {
    this.setPrices(this.props.listingType);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.listingType !== this.props.listingType) {
      this.setPrices(nextProps.listingType);
    } else if (nextProps.min !== this.props.min || nextProps.max !== this.props.max) {
      this.setState({
        minValue: nextProps.min,
        maxValue: nextProps.max
      });
    }
  }

  setPrices = (listingType) => {
    const regionData = this.props.region;
    const prices = listingType === 'rental' ?
      regionData.rentalPrices || [] :
      regionData.salePrices;
    this.setState({
      prices: prices
    });
  }

  handlePriceChange = (name, value) => {
    let min, max;
    if(name === 'minPrice') {
      min = value;
      max = this.state.maxValue;
    } else {
      min = this.state.minValue;
      max = value;
    }
    this.props.handleChange(min, max);
  }

  render() {
    const drops = (
      <div>
        <div className="price-dropdown">
          Price Min
          <DropDown
            name='minPrice'
            value={this.state.minValue}
            options={this.state.prices.slice(0, this.state.prices.length-1 > this.state.prices.map((p)=> p.value).indexOf(this.state.maxValue) ? this.state.prices.map((p)=> p.value).indexOf(this.state.maxValue)+1 : this.state.prices.length-1)}
            handleChange={this.handlePriceChange}
          />
        </div>
        <div className="price-dropdown">
          Price Max
          <DropDown
            name='maxPrice'
            value={this.state.maxValue}
            options={this.state.prices.slice(Math.max(1,this.state.prices.map((p) => p.value).indexOf(this.state.minValue)), this.state.prices.length).reverse()}
            handleChange={this.handlePriceChange}
          />
        </div>
      </div>
    );
    return (
      <div className={'hidden search-input x-large price-selector-input visible-xxs ' + this.props.className}>
        <div className="selector-controls">
          {drops}
        </div>
      </div>
    );
  }
}

PriceDropdown.propTypes = {
  className: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  listingType: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  region: PropTypes.object.isRequired
};

export default PriceDropdown;



// WEBPACK FOOTER //
// ./src/components/search/controls/price-dropdown.jsx